import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Btn from "../components/Btn";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | failed
  const { refresh } = useAuth();
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let stop = false;
    const poll = async () => {
      if (stop) return;
      tries.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); refresh(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { /* keep trying */ }
      if (tries.current >= 12) { setState("failed"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="min-h-screen grid place-items-center bg-su-bg px-4">
      <div className="card-chunky p-8 sm:p-10 max-w-md w-full text-center animate-pop">
        {state === "checking" && (
          <>
            <Loader2 className="w-16 h-16 text-su-primary mx-auto mb-4 animate-spin" />
            <h1 className="font-heading font-black text-2xl mb-2">Memverifikasi pembayaran...</h1>
            <p className="text-su-muted font-medium">Sebentar ya, kami sedang mengaktifkan fiturmu.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <div className="w-20 h-20 rounded-3xl bg-su-success/15 grid place-items-center mx-auto mb-4"><CheckCircle2 className="w-11 h-11 text-su-success" /></div>
            <h1 className="font-heading font-black text-2xl mb-2" data-testid="payment-success">Pembayaran Berhasil! 🎉</h1>
            <p className="text-su-muted font-medium mb-6">Fitur & benefit sudah aktif di akunmu.</p>
            <Link to="/dashboard"><Btn className="w-full">Ke Dashboard</Btn></Link>
          </>
        )}
        {state === "failed" && (
          <>
            <div className="w-20 h-20 rounded-3xl bg-su-danger/15 grid place-items-center mx-auto mb-4"><XCircle className="w-11 h-11 text-su-danger" /></div>
            <h1 className="font-heading font-black text-2xl mb-2">Verifikasi gagal</h1>
            <p className="text-su-muted font-medium mb-6">Pembayaran belum terkonfirmasi. Jika sudah membayar, cek dashboard beberapa saat lagi.</p>
            <Link to="/pricing"><Btn variant="ghost" className="w-full">Kembali ke Harga</Btn></Link>
          </>
        )}
      </div>
    </div>
  );
}
